import IncentiveCard from './incentive-card';

export default IncentiveCard;
